export default {
    "lv": {
        "(and {count} more error)": "(un vēl {count} kļūdas)",
        "(and {count} more errors)": "(un vēl {count} kļūdas)",
        "All rights reserved.": "Visas tiesības aizsargātas.",
        "Forbidden": "Aizliegts",
        "Go to page {page}": "Iet uz lapu {page}",
        "Hello!": "Sveiki!",
        "If you did not create an account, no further action is required.": "Ja neesat izveidojis kontu, turpmāka darbība nav nepieciešama.",
        "If you did not request a password reset, no further action is required.": "Ja neesat pieprasījis paroles atiestatīšanu, turpmāka darbība nav nepieciešama.",
        "If you're having trouble clicking the \"{actionText}\" button, copy and paste the URL below\ninto your web browser:": "Ja jums rodas problēmas, noklikšķinot uz pogas \"{actionText}\", nokopējiet un ielīmējiet tālāk norādīto URL\nsavā tīmekļa pārlūkprogrammā:",
        "Login": "Pieteikšanās",
        "Logout": "Atteikties",
        "Not Found": "Nav Atrasts",
        "of": "no",
        "Page Expired": "Lapas Derīguma Termiņš",
        "Pagination Navigation": "Pagination Navigācija",
        "Payment Required": "Nepieciešams maksājums",
        "Please click the button below to verify your email address.": "Lūdzu, noklikšķiniet uz pogas zemāk, lai pārbaudītu savu e-pasta adresi.",
        "Regards": "Saistībā",
        "Register": "Reģistrēts",
        "Reset Password": "Atiestatīt Paroli",
        "Reset Password Notification": "Atiestatīt Paroles Paziņojumu",
        "results": "rezultāts",
        "Server Error": "Servera Kļūda",
        "Service Unavailable": "Pakalpojums Nav Pieejams",
        "Showing": "Parādot",
        "The given data was invalid.": "Norādītie dati nebija derīgi.",
        "This password reset link will expire in {count} minutes.": "Šī paroles atiestatīšanas saite beigsies {count} minūtēs.",
        "to": "lai",
        "Toggle navigation": "Pārslēgt navigāciju",
        "Too Many Requests": "Pārāk Daudz Pieprasījumu",
        "Unauthorized": "Neatļauts",
        "Verify Email Address": "Pārbaudiet E-Pasta Adresi",
        "Whoops!": "Ak vai!",
        "You are receiving this email because we received a password reset request for your account.": "Jūs saņemat šo e-pastu, jo mēs saņēmām paroles atiestatīšanas pieprasījumu jūsu kontam.",
        "The provided password does not match your current password.": "Dotā parole nesakrīt ar tavu pašreizējo paroli.",
        "Progress": "Progress",
        "Dismiss": "Aizvērt"
    },
    "ru": {
        "Mācīties": "Учиться",
        "Pieslēgties": "Войти",
        "Reģistrēties": "Зарегистрироваться",
        "Iziet": "Выйти",
        "E-pasts": "Электронная почта",
        "Parole": "Пароль",
        "Atcerēties mani": "Запомнить меня",
        "Aizmirsi paroli?": "Забыли пароль?",
        "Vārds": "Имя",
        "Apstiprināt paroli": "Подтвердить пароль",
        "Jau reģistrējies?": "Уже зарегистрированы?",
        "Nosūtīt paroles atiestatīšanas saiti": "Отправить ссылку для восстановления пароля",
        "Atjaunot paroli": "Восстановить пароль",
        "Apstiprināt": "Подтвердить",
        "Saglabāts.": "Сохранено.",
        "Saglabāt": "Сохранить",
        "Atcelt": "Отмена",
        "Profils": "Профиль",
        "Profila informācija": "Информация профиля",
        "Foto": "Фото",
        "Izvēlēties jaunu foto": "Выбрать новое фото",
        "Noņemt foto": "Удалить фото",
        "Pašreizējā parole": "Текущий пароль",
        "Jaunā parole": "Новый пароль",
        "Jaunā parole atkārtoti": "Подтвердите новый пароль",
        "Dzēst kontu": "Удалить аккаунт",
        "Vai tiešām vēlaties dzēst savu kontu?": "Вы уверены, что хотите удалить свой аккаунт?",
        "Jā, dzēst kontu": "Да, удалить аккаунт",
        "Pārlūkprogrammu sesijas": "Сессии браузера",
        "Izrakstīties no citām pārlūkprogrammu sesijām": "Выйти из других сессий браузера",
        "Gatavs.": "Готово.",
        "Divu faktoru autentifikācija": "Двухфакторная аутентификация",
        "Iespējot": "Включить",
        "Atspējot": "Отключить",
        "Atkopšanas kodi": "Коды восстановления",
        "Rādīt atkopšanas kodus": "Показать коды восстановления",
        "Ģenerēt jaunus atkopšanas kodus": "Сгенерировать новые коды восстановления",
        "Kontakti": "Контакты",
        "Anotācija": "Аннотация",
        "Kā lietot Evidi?": "Как использовать Evide?",
        "Kā lietot e-vidi?": "Как использовать Evide?",
        "Mācību video": "Учебное видео",
        "Privātuma politika": "Политика конфиденциальности",
        "Vispārīgie noteikumi": "Общие условия",
        "Iesniegt": "Отправить",
        "Atkārtoti nosūtīt verifikācijas e-pastu": "Повторно отправить письмо подтверждения",
        "Jauna verifikācijas saite ir nosūtīta uz jūsu e-pasta adresi.": "Новая ссылка подтверждения отправлена на ваш email.",
        "Kods": "Код",
        "Atkopšanas kods": "Код восстановления",
        "Izmantot atkopšanas kodu": "Использовать код восстановления",
        "Izmantot autentifikācijas kodu": "Использовать код аутентификации",
        "Sveicināti atpakaļ": "Добро пожаловать обратно",
        "Moduļa tests": "Тест модуля",
        "Noslēguma tests:": "Итоговый тест:",
        "Testa atbilžu pārskats": "Обзор ответов теста",
        "Uz moduļu sarakstu": "К списку модулей",
        "Nākamais jautājums": "Следующий вопрос",
        "Iesniegt atbildes": "Отправить ответы",
        "Beigt testu": "Завершить тест",
        "Iepriekšējais jautājums": "Предыдущий вопрос",
        "Atbildēts": "Отвечено",
        "Kļūda:": "Ошибка:",
        "Lapa neeksistē": "Страница не существует",
        "Atpakaļ": "Назад",
        "Sākumlapa": "Главная",
        "Noslēguma tests": "Итоговый тест",
        "Drošības nolūkos, lūdzu, apstipriniet savu paroli, lai turpinātu.": "В целях безопасности, пожалуйста, подтвердите пароль для продолжения.",
        "Skatīties video": "Смотреть видео",
        "Nodarbības prezentācijas": "Презентации занятий",
        "Visi jautājumi atbildēti.": "Все вопросы отвечены.",
        "Pareizi atbildēti jautājumi:": "Правильно отвеченные вопросы:",
        "Tests nokārtots.": "Тест сдан.",
        "Tests nav nokārtots.": "Тест не сдан.",
        "Vēl atlikuši mēģinājumi:": "Осталось попыток:",
        "Tests netika nokārtots ar trešo reizi. Modulis ir jāapgūst no jauna.": "Тест не сдан с третьей попытки. Модуль необходимо пройти заново.",
        "Pildīt testu vēlreiz": "Пройти тест снова",
        "Apskatīt atbildes": "Посмотреть ответы",
        "Iesniegt atbildi": "Отправить ответ",
        "Profila pārvaldība": "Управление профилем",
        "Moduļi": "Модули",
        "Skatīties instrukcijas video vēlreiz": "Смотреть инструкцию видео снова",
        "Apsveicam, esi nokārtojis visus e-vides moduļus.": "Поздравляем, вы прошли все модули e-vide.",
        "Ceļu satiksmes noteikumu apguve": "Изучение правил дорожного движения",
        "Paroles maiņa": "Изменить пароль",
        "Vēl nav neviena jautājuma.": "Вопросов пока нет.",
        "Jautājums:": "Вопрос:",
        "Jautājumi": "Вопросы",
        "Atbildēt": "Отвечать",
        "Pievienot atbildi": "Добавить ответ",
        "Pievienot jautājumu": "Добавить вопрос",
        "Sekmīgi pabeigts:": "Завершено успешно:",
        "Pieejams pēc:": "Доступно после:",
        "Skatīties vēlreiz": "Смотреть снова",
        "Skatīties nākamo video": "Смотреть следующее видео",
        "Pildīt moduļa noslēguma testu": "Пройти итоговый тест модуля",
        "Validācijas jautājums": "Проверочный вопрос",
        "Tavi pienākumi BAVA autoskolā": "Ваши обязанности в автошколе BAVA",
        "Progress": "Прогресс",
        "Dismiss": "Закрыть"
    }
}
